module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-5-1aae10b01772d909451c004048288a82.svg";